import { render, staticRenderFns } from "./DocumentList-general.vue?vue&type=template&id=01b9854a&scoped=true&"
import script from "./DocumentList-general.vue?vue&type=script&lang=js&"
export * from "./DocumentList-general.vue?vue&type=script&lang=js&"
import style0 from "./DocumentList-general.vue?vue&type=style&index=0&id=01b9854a&scoped=true&lang=css&"
import style1 from "@/assets/styles/modals.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/paginations.css?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/styles/tooltips.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9854a",
  null
  
)

export default component.exports